export default {
    validation_messages: [
      {
        name: "required",
        en: "This field is required",
        fr: "L'information de ce champ est requise"
      },
      {
        name: "date",
        en: "Date must be included between 1900 and today",
        fr: "La date doit être incluse entre 1900 et aujourd'hui"
      },
      {
        name: "dateFormat",
        en: "Date must be in the format dd-mm-yyyy",
        fr: "La date doit être au format jj-mm-aaaa"
      },
      {
        name: "combinedLength",
        en: "Combined length cannot be more than 50 characters",
        fr: "La longueur ne peut pas être supérieure à 50 caractères"
      },
      {
        name: "email",
        en: "Please enter a correct email",
        fr: "Veuillez indiquer un courriel valide"
      },
      {
        name: "phone",
        en: "Please enter a 10 digit phone number",
        fr: "Veuillez indiquer un numéro de téléphone à 10 chiffres"
      },
      {
        name: "postal",
        en: "Please enter a postal code in format A1A 1A1",
        fr: "Veuillez entrer le code postal au format A1A 1A1"
      }
  
    ]
  };
  